import React from "react";
import "./headerboardMultimedia.scss";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import { OptimizeImage } from "../../../shared/utils/stringUtilities";
import { useStaticQuery, graphql } from "gatsby";

// Compontents //
import Breadcrumb from '../../atoms/breadcrumb/breadcrumb';

// Helpers //
import { formatDate } from "../../../utils/helpers";

const HeadboardMultimedia = (props: ReferenciaCabecera) => {
    const icons = useStaticQuery(graphql`
        query MEDIAICONSMULTIMEDIA {
            iconWebinar: allContentfulAsset(
                filter: { title: { eq: "icon-webinar" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconPodcast: allContentfulAsset(
                filter: { title: { eq: "icon-podcast" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconArticulo: allContentfulAsset(
                filter: { title: { eq: "icon-articulo" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconHistorias: allContentfulAsset(
                filter: { title: { eq: "icon-historias" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconLike: allContentfulAsset(
                filter: { title: { eq: "icon-like" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconTime: allContentfulAsset(
                filter: { title: { eq: "icon-time" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
        }
    `);

    const iconWebinar: string = icons.iconWebinar.nodes[0].file.url;
    const iconPodcast: string = icons.iconPodcast.nodes[0].file.url;
    const iconArticulo: string = icons.iconArticulo.nodes[0].file.url;
    const iconHistorias: string = icons.iconHistorias.nodes[0].file.url;
    const iconTime: string = icons.iconTime.nodes[0].file.url;

    const switchIcons = (icon) => {
        switch (icon) {
            case "Artículo":
                return iconArticulo;
            case "Podcast":
                return iconPodcast;
            case "Webinar":
                return iconWebinar;
            case "Historias que conectan":
                return iconHistorias;
            default:
                return "";
        }
    }

    const { referenciaMultimedia: refMultimedia } = props;

    return (
        <div className="o-headboard-multimedia">
            <div className="container">
                <Breadcrumb content={props.migaDePan} />
                {refMultimedia.categoriaMultimedia != "Historias que conectan" && refMultimedia.categoriaMultimedia != "Webinar" && (
                    <div className="o-headboard-multimedia__container">
                        <div className="o-headboard-multimedia__container__content">
                            <div className="o-headboard-multimedia__container__content__type">
                                <img src={switchIcons(refMultimedia.categoriaMultimedia)} alt={refMultimedia.categoriaMultimedia} />
                                {refMultimedia.categoriaMultimedia}
                            </div>
                            <h1 className="o-headboard-multimedia__container__content__title">
                                {refMultimedia.tituloMultimedia}
                            </h1>
                            <span className="o-headboard-multimedia__container__content__span">
                                {refMultimedia.tematica}
                            </span>
                            <article className="o-headboard-multimedia__container__content__text">
                                {refMultimedia.textoIntroductorio}
                            </article>
                            <div>
                                <span className="o-headboard-multimedia__container__content__date">
                                    {formatDate(refMultimedia.createdAt)}
                                </span>
                                {refMultimedia.categoriaMultimedia == "Artículo" && (
                                    <span className="o-headboard-multimedia__container__content__readingtime">
                                        <img src={iconTime} ></img>
                                        {`Te demoras ${refMultimedia.tiempoLectura} leyendo este artículo`}
                                    </span>
                                )}
                            </div>
                        </div>
                        {refMultimedia.imagenPrincipal ? (
                            <div className="o-headboard-multimedia__container__cover">
                                {refMultimedia.imagenPrincipal && (
                                    <img
                                        className="o-headboard-multimedia__container__cover__img"
                                        src={OptimizeImage(
                                            refMultimedia.imagenPrincipal.fields.file.url,
                                            refMultimedia.imagenPrincipal.fields.file.contentType,
                                            550
                                        )}
                                        alt={
                                            (refMultimedia.imagenPrincipal &&
                                                refMultimedia.imagenPrincipal.title) ||
                                            "imagen cabecera"
                                        }
                                        loading="lazy"
                                    />
                                )}
                            </div>
                        ) : null}
                    </div>
                )}
                {refMultimedia.categoriaMultimedia == "Historias que conectan" || refMultimedia.categoriaMultimedia == "Webinar" ? (
                    <div className="o-headboard-multimedia__webinar-container">
                        <div className="o-headboard-multimedia__container__content">
                            <h1 className="o-headboard-multimedia__container__content__title">
                                {refMultimedia.tituloMultimedia}
                            </h1>
                            <span className="o-headboard-multimedia__container__content__span">
                                {refMultimedia.tematica}
                            </span>
                            <div className="o-headboard-multimedia__container__content__bottom">
                                <div className="o-headboard-multimedia__container__content__type">
                                    <img src={switchIcons(refMultimedia.categoriaMultimedia)} alt={refMultimedia.categoriaMultimedia} />
                                    {refMultimedia.categoriaMultimedia}
                                </div>
                                <span>{formatDate(refMultimedia.createdAt)}</span>
                            </div>
                        </div>
                        {refMultimedia.video?.fields.file.url ? (
                            <video controls poster={refMultimedia.imagenPrincipal.fields.file.url}>
                                <source src={refMultimedia.video?.fields.file.url} type={refMultimedia.video?.fields.file.contentType} />
                            </video>
                        ) : (
                            <iframe
                                src={refMultimedia.videoUrl}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
                            </iframe>
                        )}
                    </div>
                ) : (
                    <></>
                )
                }
            </div>
        </div>
    );
};

export default HeadboardMultimedia;
